import { render, staticRenderFns } from "./BoxFields.vue?vue&type=template&id=4a5f4b45&scoped=true&"
import script from "./BoxFields.vue?vue&type=script&lang=js&"
export * from "./BoxFields.vue?vue&type=script&lang=js&"
import style0 from "./BoxFields.vue?vue&type=style&index=0&id=4a5f4b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f4b45",
  null
  
)

export default component.exports